import { useCallback, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { ApiData } from "../ApiData";
import { ExClient } from "../ExClient";

interface Form {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  company_name: string;
  website: string;
  company_country_code: string;
  turnover: string;
  company_industry: string;
  agree_terms: boolean;
  captcha: string;
}

export const useIbanForm = () => {
  const [loading, setLoading] = useState(false);
  const captchaRef = useRef(null);
  const formModel = useForm<Form>({
    defaultValues: {
      company_country_code: ExClient.ip_country_code
    }
  });
  const onSubmit = useCallback(async (data: Form) => {
    setLoading(true);
    try {
      const { success, message } = await ApiData.publicApiRequest(
        {
          ...data,
          "g-recaptcha-response": data.captcha
        },
        "send_corp_mail"
      );
      captchaRef.current.reset();

      if (!success) return toast.error(message);
      formModel.reset();
      toast.success("Thank You for Your request!");
    } catch {
    } finally {
      setLoading(false);
    }
  }, []);
  const onCaptchaChange = (value: string) => {
    formModel.setValue("captcha", value, { shouldValidate: true });
  };
  return { formModel, captchaRef, onSubmit, onCaptchaChange, loading };
};
